import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import BackComponent from 'screens/back';
import { Table, Pagination, Tooltip, Input, CheckboxTable, Modal, Select, DatePicker } from 'components';
import { TrashIcon, EditIcon, CleanIcon, AddWhiteIcon, TrashWhiteIcon, ConfirmIcon, StarIcon, CopyIcon, Menu as MenuIcons, SettingsIcon } from 'assets/icons';
import { Globals, checkPermission, Constants } from 'utils';
import { PointService } from 'services';
import moment from 'moment';
import ModalChangePoints from './change-points';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: ''
}

class Points extends React.Component<Props> {

	timer: any = undefined;

	state = {
		form: INITIAL_STATE,
		page: 1,
		last_page: 1,
		data: [],
		header: [
			'Usuario',
			'Registrados por Invitación',
			'Personas con servicios concretados',
			'Descuentos Obtenidos',
			'Descuentos Usados'
		],
		quantity_required: 0,
		visible: false,
		prize_percent: 0
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Referidos',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await PointService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
		});
		this.setState({
			data: res.users.rows,
			last_page: res.users.count,
			quantity_required: res.quantity_required || 0,
			prize_percent: res.prize_percent || 0
		});
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	onClose = () => {
		this.setState({
			visible: false
		},() => this.load(true));
	}

	open = () => {
		this.setState({
			visible: true
		});
	}

	render() {
		const { visible } = this.state;

		return (
			<div id="my-points">
				<BackComponent />

				<Modal
		          className="modal-change-price"
		          visible={ visible }
		          title=""
		          centered
		          withoutClose={ true }
		          onClose={ () => this.onClose() }
		        >
		        	<ModalChangePoints
		        		onClose={ () => this.onClose() }
		        		quantity_required={ this.state.quantity_required }
		        		prize_percent={ this.state.prize_percent }
		        	/>
		      	</Modal>

				<div className="row row-filter">
					<div className="col-md-12 row">
						<div className="col-md-3">
							<Input
								searchLeft
								value={ this.state.form.search }
								name="search"
								placeholder="Buscar por usuario"
								className="input-table"
								onSubmit={ () => this.load() }
								onChange={ (e: any) => {
									clearTimeout(this.timer);
									this.timer = setTimeout(() => {
										this.load(true);
									},1000);
									this.change(e); 
								} } />
						</div>
						<div className="col-md-3">
							{
								this.state.form != INITIAL_STATE && (
									<button className="btn btn-clean" onClick={ () => this.reset() }>
										<img src={ CleanIcon } />
									</button>
								)
							}
						</div>
					</div>
				</div>

				{
					checkPermission(Constants.MODULES.SERVICES,'write') && (
						<button className="btn btn-calendar" onClick={ () => this.open() }>
							<img src={ SettingsIcon } />
							Configuración
						</button>
					)
				}

				<Table data={ this.state.data.length } header={ this.state.header }>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>{ (i?.name || '') + ' ' + (i?.lastname || '') }</td>
								<td>{ i.quantity_referrals }</td>
								<td>{ i.quantity_purchases }</td>
								<td>{ i.quantity_discounts }</td>
								<td>{ i.quantity_use }</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Points);